import { render, staticRenderFns } from "./AdminSign.vue?vue&type=template&id=371cd30c&scoped=true"
import script from "./AdminSign.vue?vue&type=script&lang=ts"
export * from "./AdminSign.vue?vue&type=script&lang=ts"
import style0 from "./AdminSign.vue?vue&type=style&index=0&id=371cd30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371cd30c",
  null
  
)

export default component.exports